import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionRole, ButtonType } from '@newroom-connect/library/enums';
import { IActionButton, IActionButtonEvent } from '@newroom-connect/library/interfaces';
import { DrawItemPipe, FirstCharOfWordsPipe, ToStringPipe } from '@newroom-connect/library/pipes';

import { ButtonComponent } from '../../../buttons/button/button.component';
import { IconComponent } from '../../../icon/icon.component';
import { MediaPreviewComponent } from '../../../media-preview/media-preview.component';

export interface IRowCardItemConfiguration {
  icon?: string;
  title: string;
  subtitle?: string;
  actionButtons?: IActionButton[];
  isSelected?: boolean;
  disabled?: boolean;
  thumbnailConfig?: {
    backgroundColorClasses?: string[];
    thumbnailSourceKey?: string;
    fallbackThumbnailSourceKey?: string;
    mimetypeKey?: string;
    fallbackMimetypeKey?: string;
  };
  thumbnailSource?: string;
  mimetype?: string;
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    IconComponent,
    MediaPreviewComponent,
    DrawItemPipe,
    FirstCharOfWordsPipe,
    ToStringPipe
  ],
  selector: 'nrc-row-card-item',
  templateUrl: './row-card-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RowCardItemComponent {
  @Input({ required: true }) public config!: IRowCardItemConfiguration;
  @Input() public index?: number;

  @Output() public itemClickEvent = new EventEmitter<{ index?: number }>();
  @Output() public actionButtonEvent = new EventEmitter<IActionButtonEvent>();

  public actionRole = ActionRole;
  public buttonType = ButtonType;

  /**
   * Handle item click event if the item is not disabled.
   */
  public handleItemClick(): void {
    if (this.config.disabled) {
      return;
    }

    this.itemClickEvent.emit({ index: this.index });
  }

  /**
   * Handle action button click event. Skip if action button or item are disabled.
   *
   * @param actionButton - The clicked action button.
   */
  public handleActionButtonClick(actionButton: IActionButton): void {
    if (actionButton.disabled || this.config.disabled) {
      return;
    }

    // Emit the action button event and item click event to simulate selection as well.
    this.itemClickEvent.emit({ index: this.index });

    this.actionButtonEvent.emit({
      actionButton,
      index: this.index
    });
  }
}
